import {
    DeviceData,
    DeviceStatus,
    DeviceListQuery,
    DeviceCreateForm,
    DeviceUpdateForm,
    DeviceListResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/device';

export class DeviceApi {
    public static async getList(params?: DeviceListQuery): Promise<DeviceData[]> {
        const res = await axios.get<DeviceListResponse>(`${BASE_URL}`, { params });

        return res.data.devices;
    }

    public static async create(device: DeviceCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}`, { device });
    }

    public static async update(id: string, device: DeviceUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { device });
    }

    public static async updateStatus(id: string, status: DeviceStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${id}/status`, { device: { status } });
    }
}
